/* Attachment constants + pure validation extracted from Chat.tsx (decomposition, */
/* Phase 4). Behaviour-identical — Chat.tsx re-imports these. PDF is read natively */
/* by Gemini; Office docs have their text extracted server-side (EDU-100). */

export const MAX_FILE_BYTES = 10 * 1024 * 1024; /* 10 MB */

export const IMAGE_MIMES = ['image/jpeg', 'image/png', 'image/heic', 'image/webp'];
export const DOC_MIMES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
export const ACCEPTED = [...IMAGE_MIMES, ...DOC_MIMES];

export const isImageMime = (m: string) => m.startsWith('image/');

/** A file the user picked but hasn't sent yet (with its object-URL preview). */
export interface PendingAtt {
  id: string;
  file: File;
  previewUrl: string;
}

/** Returns an error message if the file is rejected, or null if it's accepted. */
export function validateAttachmentFile(file: { name: string; type: string; size: number }): string | null {
  if (!ACCEPTED.includes(file.type)) return `Format non supporté : ${file.name} (${file.type || 'inconnu'}).`;
  if (file.size > MAX_FILE_BYTES) return `Fichier trop lourd : ${file.name} (10 Mo max).`;
  return null;
}
